module.exports = __webpack_public_path__ + "img/car-2.98a8e484.jpg";